import { shade, tint } from 'polished'
import styled from 'styled-components'

interface DatePickerStyledProps {
  error?: boolean
}

export const DatePickerStyled = styled.div<DatePickerStyledProps>`
  display: flex;

  .rdp-root {
    --rdp-accent-color: ${(props) =>
      props.theme.colors.form.datepicker.selected};
    --rdp-background-color: ${(props) =>
      tint(0.7, props.theme.colors.form.datepicker.selected)};
    --rdp-range_middle-background-color: ${(props) =>
      props.theme.colors.transparent};

    --rdp-months-gap: ${(props) => props.theme.space.small};

    --rdp-day-height: ${(props) => props.theme.typography.pxToRem(34)};
    --rdp-day-width: ${(props) => props.theme.typography.pxToRem(33)};

    --rdp-day_button-height: ${(props) => props.theme.typography.pxToRem(34)};
    --rdp-day_button-width: ${(props) => props.theme.typography.pxToRem(33)};

    font-family: ${(props) => props.theme.typography.fontFamily};
    font-size: ${(props) => props.theme.typography.pxToRem(14)};
  }

  .rdp-months {
    flex-wrap: nowrap;
  }

  .rdp-day {
    font-size: ${(props) => props.theme.typography.pxToRem(12)};
  }

  .rdp-day_button:hover {
    background-color: var(--rdp-background-color);
  }

  .rdp-selected .rdp-day_button {
    background-color: var(--rdp-accent-color);
    color: ${(props) => props.theme.colors.white};
  }

  .rdp-range_start .rdp-day_button {
    border-radius: 50% 0 0 50%;
  }

  .rdp-range_end .rdp-day_button {
    border-radius: 0 50% 50% 0;
  }

  .rdp-range_middle .rdp-day_button {
    background-color: var(--rdp-background-color);
    border-radius: 0;
    color: inherit;
  }

  .rdp-range_start.rdp-range_end .rdp-day_button {
    border-radius: 50%;
  }

  .rdp-today:not(.rdp-selected) .rdp-day_button {
    background-color: ${(props) =>
      tint(0.85, props.theme.colors.form.datepicker.selected)};
    color: ${(props) =>
      shade(0.2, props.theme.colors.form.datepicker.selected)};
  }

  .rdp-month_caption {
    font-size: ${(props) => props.theme.typography.pxToRem(14)};
    font-weight: ${(props) => props.theme.fontWeights.semibold};
  }

  .rdp-weekday {
    font-size: ${(props) => props.theme.typography.pxToRem(12)};
  }

  .rdp-dropdown {
    cursor: pointer;
  }

  .rdp-caption_label {
    gap: ${(props) => props.theme.space.xsmall};

    .rdp-chevron {
      width: ${(props) => props.theme.typography.pxToRem(12)};
      height: ${(props) => props.theme.typography.pxToRem(12)};
      fill: ${(props) => props.theme.colors.darkGrey};
    }
  }
`
